const model = {
    warehouseDetails: null,
    loading: false,
    error: null,
};

export default model;